/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import {
    FETCH_IDS_DETAILS_REQUEST,
    FETCH_IDS_DETAILS_SUCCESS,
    FETCH_IDS_DETAILS_FAILURE,
} from "./IdsTypes";
  
  const initialState = {
    loading: false,
    ids: [],
    error: "",
  };
  
  const idsReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_IDS_DETAILS_REQUEST:
        return {
          ...state,
          loading: true,
        };
  
      case FETCH_IDS_DETAILS_SUCCESS:
        return {
          loading: false,
          ids: action.payload,
          error: "",
        };
      case FETCH_IDS_DETAILS_FAILURE:
        return {
          loading: false,
          ids: {},
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default idsReducer;
  